/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IncomingPaymentDto } from './incomingPaymentDto.model';


export interface IncomingPaymentGroupedByYearContractDto { 
    amount?: number;
    contractId?: number;
    paymentYear?: number;
    payments?: Array<IncomingPaymentDto>;
}

